import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import { HeadsetMic, PinDrop, GpsFixed } from "@material-ui/icons";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";

import styles from "assets/jss/material-kit-react/views/componentsSections/pillsStyle.js";

const useStyles = makeStyles(styles);

export default function FeatureComponent() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <div id="navigation-pills">
          <div className={classes.title}>
            <h3>
              <strong>Features of our Device</strong>
            </h3>
          </div>
          <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
            We are fully committed to making our product as compact and
            user-friendly as possible. So He/She can easily use Navigation by
            Drishti.{" "}
          </p>
          <div className={classes.title}>
            <h3>{/* <small>With Icons</small> */}</h3>
          </div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <NavPills
                color="info"
                tabs={[
                  {
                    tabButton: "GPS Navigation",
                    tabIcon: GpsFixed,
                    tabContent: (
                      <span>
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          Avoiding all the Obstacles and Giving user all the
                          information about his environment to make it more
                          interactive plus user friendly.
                        </p>
                        <br />
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          Accuracy more than GPS based products and service
                          providers.Those who have tried to target the same
                          issues have used GPS for navigation which does not
                          provide real-time obstacle detection.
                        </p>
                        <br />
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          Our products do obstacle sensing using sensors as well
                          rather than just simple image processing which
                          increases accuracy.
                        </p>
                      </span>
                    ),
                  },
                  {
                    tabButton: "Voice Support",
                    tabIcon: HeadsetMic,
                    tabContent: (
                      <span>
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          He/She can also select a specific route for navigation
                          using an inbuilt chatbot which will be tracked using
                          GPS in real-time and help him reach his destination.
                        </p>
                        <br />
                        {/* <p>
                          Dramatically visualize customer directed convergence
                          without revolutionary ROI. Collaboratively
                          administrate empowered markets via plug-and-play
                          networks. Dynamically procrastinate B2C users after
                          installed base benefits.
                        </p>
                        <br />
                        <p>
                          Dramatically visualize customer directed convergence
                          without revolutionary ROI. Collaboratively
                          administrate empowered markets via plug-and-play
                          networks. Dynamically procrastinate B2C users after
                          installed base benefits.
                        </p> */}
                      </span>
                    ),
                  },
                  {
                    tabButton: "Drop Location",
                    tabIcon: PinDrop,
                    tabContent: (
                      <span>
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          We are planning to integrate our product with Google
                          Maps to assist the user in reaching his destination by
                          providing directional assistance.
                        </p>
                        <br />
                        {/* <p>
                          Dramatically maintain clicks-and-mortar solutions
                          without functional solutions. Dramatically visualize
                          customer directed convergence without revolutionary
                          ROI. Collaboratively administrate empowered markets
                          via plug-and-play networks. Dynamically procrastinate
                          B2C users after installed base benefits.
                        </p> */}
                      </span>
                    ),
                  },
                ]}
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
